"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dribbble = void 0;
var types_1 = require("../types");
exports.dribbble = {
    name: 'dribbble',
    matches: [
        {
            match: '(https?://)?(www.)?dribbble.com/({PROFILE_ID})/?', group: 3, type: types_1.TYPE_DESKTOP,
            pattern: 'https://dribbble.com/{PROFILE_ID}'
        },
        { match: '({PROFILE_ID})', group: 1 },
    ]
};
//# sourceMappingURL=dribbble.js.map